/** Suivi des pointages — comparaison centralisée pour TOUTES les activités.
 *
 * La source des heures prévues est déduite de l'activité de l'employé :
 *  - boulangerie / traiteur / chambre froide / office → planning hebdo (types + overrides)
 *  - cleaning             → planning horaire lié à l'assignation nettoyage du jour
 *  - driving              → somme des durées des legs (tournées) du jour
 */

import { Header } from '../components/layout/Header';
import { ComparisonTab } from './SchedulesPage';

export function PointingControlPage() {
  return (
    <div>
      <Header title="Suivi des pointages" />
      <p className="text-xs text-stone-500 mb-4">
        Comparaison des pointages par rapport aux plannings de toutes les activités
        (boulangerie, traiteur, chambre froide, nettoyage, chauffeurs, bureau).
      </p>
      <ComparisonTab showActivityFilter />
    </div>
  );
}
